define('uikit/modules/message',['require','exports','module','underscore','marionette','handlebars','../mixins/component.mixin','../channel','../extra/size','../extra/color','templates'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var handlebars = require('handlebars');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var Templates = require('templates');

  var MessageListItem = Mn.ItemView.extend(ComponentMixin).extend({

    tagName: 'li',

    template: function(data) { return handlebars.escapeExpression(data.text); },

    options: {
      text: ''
    },

    forceUpdate: { text: true }

  });

  var Message = Mn.CompositeView.extend(ComponentMixin).extend({

    tagName: 'div',

    className: 'ui message',

    childView: MessageListItem,

    childViewContainer: '@ui.listContainer',

    childViewEventPrefix: 'listItem',

    template: Templates.App['message'],

    ui: {
      listContainer: '.list',
      textElement: '.text'
    },

    options: {
      attached: false,
      dismissable: false,
      collection: null,
      compact: false,
      color: '',
      header: '',
      format: '',
      floating:false,
      text: '',
      size: '',
      visible: true
    },

    forceUpdate: {
      attached: true,
      dismissable: true,
      collection: true,
      compact: true,
      color: true,
      header: true,
      format: true,
      floating: true,
      text: true,
      size: true,
      visible: true
    },

    formatOptionValues: [
      'warning',
      'info',
      'positive',
      'success',
      'negative',
      'error'
    ],
    sizeOptionValues: _.values(Size),
    colorOptionValues: _.values(Color),

    events: {
      'click .close.icon' : 'hide'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.on('render:empty', function() {
        if (this.ui.listContainer) {
          this.ui.listContainer.hide();
        }
      });
      this.on('remove:empty', function() {
        if (this.ui.listContainer) {
          this.ui.listContainer.show();
        }
      });
    },

    updateAttributes: function() {
      this.addClass('attached', this.getBoolOption('attached'));
      this.addClass('compact', this.getBoolOption('compact'));
      this.addClass('floating', this.getBoolOption('floating'));

      this.addClass(this.getOption('color'), this.getBoolOption('color'));
      this.addClass(this.getFormatOption(), this.getBoolOption('format'));
      this.addClass(this.getSizeOption(), this.getBoolOption('size'));
      if (!this.collection || this.collection.length <= 0) {
        if (this.ui.textElement) {
          this.ui.textElement.css('margin-bottom', '0');
        }
        this.ui.listContainer.css('display', 'none');
      }
      else {
        if (this.ui.textElement) {
          this.ui.textElement.css('margin-bottom', '');
        }
        this.ui.listContainer.css('display', '');
      }
    },

    getSizeOption: function() {
      switch (this.size) {
        case 'small':
        case 'sm':
        case 0:
          return 'small';
        case 'large':
        case 'lg':
        case 1:
          return 'large'
        case 'huge':
        case 'xl':
        case 2:
          return 'huge';
        case 'massive':
        case 'xxl':
        case 3:
          return 'massive';
        default:
          return '';
      }
    },

    getColorOption: function() {
      switch (this.color) {
        case 'black':
        case 'yellow':
        case 'green':
        case 'blue':
        case 'orange':
        case 'purple':
        case 'pink':
        case 'red':
        case 'teal':
          return this.color;
        default:
          return '';
      }
    },

    getFormatOption: function() {
      switch (this.format) {
        case 'warning':
        case 'info':
        case 'positive':
        case 'success':
        case 'negative':
        case 'error':
          return this.format;
        default:
          return '';
      }
    }

  });


  channel.reply('message', function() {
    return Message;
  });

  module.exports = Message;

});
